import React from 'react';
import classnames from 'clsx';
import PropTypes from 'prop-types';
import { Button } from 'ui-components/components/button';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { FormattedMessagePropType } from '../../prop-types/intl';

import style from './style.module.less';

// this is intended for a quick, reusable footer  with no frills. If you need heavy customization, make it from scratch
const ModalFooterWithActions = ({
  actionMessage,
  onAction,
  actionTheme = '',
  cancelMessage = null,
  isActionDisabled = false,
  onCancel,
  footerClassName = '',
  extraActionNode,
  actionAmplitudeTrackingId,
}) => {
  return (
    <ModalFooter className={classnames(style.footer, footerClassName)}>
      {!!extraActionNode && <div className={style.extra}>{extraActionNode}</div>}
      {!!onCancel && (
        <Button className={style.cancel} onClick={onCancel} theme='tertiary'>
          {cancelMessage || ''}
        </Button>
      )}
      <Button
        className={style.action}
        disabled={isActionDisabled}
        onClick={onAction}
        amplitudeTrackingId={actionAmplitudeTrackingId}
        theme={actionTheme}
      >
        {actionMessage}
      </Button>
    </ModalFooter>
  );
};

ModalFooterWithActions.propTypes = {
  actionMessage: FormattedMessagePropType.isRequired,
  actionTheme: PropTypes.string,
  onAction: PropTypes.func.isRequired,
  cancelMessage: FormattedMessagePropType,
  onCancel: PropTypes.func,
  footerClassName: PropTypes.string,
  isActionDisabled: PropTypes.bool,
  extraActionNode: PropTypes.node,
  actionAmplitudeTrackingId: PropTypes.string,
};

export default ModalFooterWithActions;
